const brandsNotRequiringTC = new Set(['homeaway_us', 'vrbo', 'vr', 'homeaway_ca', 'homeaway_mx']);

function isTCRequired(brand) {
    if (brandsNotRequiringTC.has(brand)) {
        return false;
    }
    return true;
}
module.exports = {
    isTCRequired
};
